import React from 'react';
import { TUserNotification } from '../../ducks/api-ducks/user-notifications-duck/types-user-notifications';
import { useNotificationsColumns, useNotificationsRows } from './hooks';
import { CustomMEMTable } from '../../shared-components/custom-mem-table';
import { userNotificationRowFormatter } from './user-notification-row-formatter';

interface IProps {
  notifications: TUserNotification[];
  isLoading?: boolean;
}

const COMPONENT_NAME = 'UserNotificationsTable';

const UserNotificationsTable = (props: IProps) => {
  const { notifications, isLoading = false } = props;
  const notificationsTableColumns = useNotificationsColumns();
  const notificationRows = useNotificationsRows(notifications);
  return (
    <CustomMEMTable
      isLoading={isLoading}
      componentName={COMPONENT_NAME}
      rowsData={notificationRows}
      columnsInfo={notificationsTableColumns}
      showFilterBox={false}
      rowFormatter={userNotificationRowFormatter}
    />
  );
};

export default UserNotificationsTable;
